import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "info-outline",
  class: "row col-xs-12 items-center"
}
const _hoisted_2 = { class: "row col-xs-12 col-md-9 items-center s-form-input_wrapper wrap-anyway base-margin-top" }
const _hoisted_3 = { class: "row col-xs-12 justify-end" }

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import Draggable from 'vuedraggable';
import { HeaderCellType } from 'SharedDir/declarations/fields';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { DELAY_TOOLTIP } from 'SharedDir/constants/common';
import { ref } from 'vue';

import HeaderCellItem from './HeaderCell.vue';
import HeaderCell from './header-cell';

export interface Props extends PropValue<null | Array<HeaderCell>> {
  readonly?: boolean;
  index: number;
  maxColspan: number;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'HeaderRow',
  components: {
    HeaderCellItem,
    Draggable,
  },
},
  __name: 'HeaderRow',
  props: {
    readonly: { type: Boolean, default: false },
    index: {},
    maxColspan: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits, { transform: (v) => v ?? [] });
const delayTooltip = DELAY_TOOLTIP;

const expanded = ref(false);

const itemDefaultValue = (extra: Partial<HeaderCellType> = {}) => {
  return new HeaderCell(extra);
};

const removeItem = (cellIndex: number) => {
  innerValue.value.splice(cellIndex, 1);
};

const addCell = () => {
  innerValue.value.push(itemDefaultValue({ order: innerValue.value.length }));
  emitValue();
};

const refreshCellOrder = () => {
  innerValue.value.forEach((field, index) => {
    field.order = index;
  });
  emitValue();
};

// }

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_q_expansion_item, {
      modelValue: expanded.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((expanded).value = $event)),
      class: "col-xs-12 section__item",
      "switch-toggle-side": "",
      "header-class": "items-center"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createElementVNode("span", null, " Строка " + _toDisplayString(_ctx.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, { side: "" }, {
          default: _withCtx(() => [
            _createVNode(SBtn, {
              class: "q-ml-lg",
              type: "icon",
              icon: "las la-trash-alt",
              tooltip: "Удаление строки",
              disabled: _ctx.readonly,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.readonly && _ctx.$emit('remove')))
            }, null, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.readonly)
              ? (_openBlock(), _createBlock(SBtn, {
                  key: 0,
                  type: "brand",
                  icon: "add",
                  onClick: addCell
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      "content-class": "s-tooltip",
                      delay: _unref(delayTooltip)
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Добавить ячейку таблицы ")
                      ])),
                      _: 1
                    }, 8, ["delay"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_unref(Draggable), {
          modelValue: _unref(innerValue),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
          "item-key": "order",
          tag: "div",
          class: "row col-xs-12 col-md-9 s-form-input_wrapper wrap-anyway",
          "ghost-class": "section-field__item--ghost",
          "draggable-class": "section-field__item--draggable",
          animation: "200",
          disabled: _ctx.readonly,
          easing: "cubic-bezier(1, 0, 0, 1)",
          onEnd: refreshCellOrder
        }, {
          item: _withCtx(({ index: i }) => [
            _createVNode(HeaderCellItem, {
              modelValue: _unref(innerValue)[i],
              "onUpdate:modelValue": [($event: any) => ((_unref(innerValue)[i]) = $event), _unref(emitValue)],
              class: "base-margin-bottom",
              "max-colspan": _ctx.maxColspan,
              readonly: _ctx.readonly,
              onRemove: ($event: any) => (removeItem(i))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "max-colspan", "readonly", "onRemove"])
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})